export namespace Constants {
  export const localStorageKeys = {
    language: process.env.REACT_APP_LOCAL_STORAGE_KEY_LANGUAGE!,
    theme: process.env.REACT_APP_LOCAL_STORAGE_KEY_THEME!,
    userData: process.env.REACT_APP_LOCAL_KEY_USER_DATA!,
  };
  export const color = {
    primary:"#AD0067"
  }
}
